import React, { useEffect, useMemo } from "react";
import { connect } from "react-redux";
import { ReactComponent as FyorinLogo } from "./assets/fyorin-logo.svg";
import { Actions as COMPANYACTIONS } from "../../../store/actions/companyActions";
import { Actions as FYORINACTIONS } from "./store/fyorinActions";
import { CheckCircleIcon, XCircleIcon } from "@heroicons/react/20/solid";
import Spinner from "@/common/Spinner";
import { ActionListOption } from "@/common/custom-selectors/ActionList";

const PayWithFyorin = ({
	period,
	isFyorin,
	userPermissions,
	setBankTransferModal,
	setBankTransferPeriod,
	getPayrollUpdate,
	largeButton,
	action,
}) => {
	const { summary, fyorinId, fyorinStatus, id: periodId } = period || {};
	const failed = ["REJECTED", "CLOSED", "EXPIRED"].includes(fyorinStatus);
	const pending = ["SUBMITTED", "APPROVED", "IN_PROGRESS"].includes(fyorinStatus);
	const success = period.fyorinStatus == "COMPLETE";

	const statusName = fyorinStatus
		?.split("_")
		?.map((c) => c[0].toUpperCase() + c.substring(1).toLowerCase())
		?.join(" ");

	const icons = {
		success: {
			icon: CheckCircleIcon,
			color: "green",
		},
		pending: {
			icon: Spinner,
			color: "green",
			className: "animate-spin -ml-1 mr-3",
		},
		failed: {
			icon: XCircleIcon,
			color: "red",
		},
	};

	const [Icon, color, className] = useMemo(() => {
		const status = failed ? "failed" : pending ? "pending" : success ? "success" : null;

		const icon = status ? icons[status] : null;

		if (!icon) return [];

		return [icon?.icon, icon?.color, icon?.className];
	}, [failed, pending, success]);

	const openBankTransfer = () => {
		setBankTransferModal(true);
		setBankTransferPeriod(period);
	};

	useEffect(() => {
		if (isFyorin && fyorinId && pending && periodId) {
			getPayrollUpdate(periodId);
		}
	}, []);

	if (!isFyorin || userPermissions) {
		return null;
	}

	if (!action && largeButton)
		return (
			<button
				className="btn btn-default"
				onClick={() => {
					if ((!fyorinId && summary?.net) || failed) openBankTransfer();
				}}
			>
				<div style={{ height: "1.5em", width: "1.5em", float: "left", marginRight: 5 }}>
					<FyorinLogo style={{ height: "1.5em", width: "1.5em", float: "left" }} />
					{Icon ? (
						<Icon
							style={{
								color,
								height: "0.75em",
								position: "relative",
								left: "-0.5em",
								bottom: "-0.6em",
							}}
							className={className}
						/>
					) : null}
				</div>
				<div style={{ float: "left" }}>{statusName && !failed ? statusName : "Send Payments"}</div>
			</button>
		);

	if (!action && fyorinId) {
		return (
			<div
				title={statusName}
				type="button"
				style={{
					height: "1.5em",
					width: "1.5em",
					borderRadius: "50%",
					position: "relative",
					cursor: "pointer",
					marginLeft: 10,
				}}
			>
				<FyorinLogo style={{ width: 24.5, height: 24.5 }} />
				{Icon ? (
					<Icon
						style={{
							color,
							width: 15,
							position: "relative",
							top: -12,
							right: -14,
						}}
						className={className}
					/>
				) : null}
			</div>
		);
	}

	if (action && !pending && !success)
		return (
			<ActionListOption
				option={{
					label: "Pay by Fyorin",
					icon: FyorinLogo,
					onClick: () => openBankTransfer(),
				}}
			/>
		);

	return null;
};

const mapStateToProps = (state, { period }) => {
	const { fyorin } = state?.integration?.payment || {};
	const userPermissions = state?.permissions?.my?.permissions?.payroll == "Read";

	return {
		userPermissions,
		isFyorin: !!fyorin,
	};
};

const mapDispatchToProps = (dispatch) => ({
	setBankTransferPeriod: (period) => dispatch(COMPANYACTIONS.setBankTransferPeriod(period)),
	setBankTransferModal: () => dispatch(COMPANYACTIONS.setBankTransferModal(true)),
	getPayrollUpdate: (payPeriodId) => dispatch(FYORINACTIONS.getPayrollUpdate(payPeriodId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(PayWithFyorin);
